// Определение материала электрода свечи по артикулу (эвристика по маркерам брендов).
// Цвета задаёт владелец: никель/медь — оранжевый, платина — синий, иридий — зелёный, рутений — фиолетовый.

export type Material = 'nickel' | 'platinum' | 'iridium' | 'ruthenium';

export const MATERIAL_COLORS: Record<Material, string> = {
    nickel: '#AB5639',
    platinum: '#3282F6',
    iridium: '#377D22',
    ruthenium: '#7F82BB',
};

export function refMaterial(brand: string, ref: string): Material {
    const r = (ref || '').toUpperCase().trim();
    const b = (brand || '').toUpperCase();

    // Рутений — фишка NGK (маркер RX)
    if (b.includes('NGK') && /RX/.test(r)) return 'ruthenium';

    if (b.includes('DENSO')) {
        if (/^(IK|IX|IA|IW|IT|IU|IKH|IXEH|VK|VFK|VW|SVK|SK|FK|FXE|FXU)/.test(r)) return 'iridium';
        if (/^PK/.test(r)) return 'platinum';
        return 'nickel';
    }
    if (b.includes('NGK')) {
        if (/IX/.test(r) || /^(IFR|ILFR|ILKAR|ILZKAR|ILZKR|DILKAR|DILFR|DILZKAR|LKAR|LFR|LZKAR|LZFR)/.test(r)) return 'iridium';
        if (/GP$/.test(r) || /^(PFR|PZFR|PTR|PLFR|PLZFR|PLKR)/.test(r) || /[EK]P[-A-Z]?[0-9]/.test(r) || /KP[AB]/.test(r) || /[EK]GP/.test(r)) return 'platinum';
        return 'nickel';
    }
    if (b.includes('BOSCH')) {
        if (/KI|II|NI/.test(r)) return 'iridium';
        if (/PP|[DKLF]P|P[0-9X+]/.test(r)) return 'platinum';
        return 'nickel';
    }
    if (b.includes('CHAMPION')) {
        if (/IX|IR/.test(r)) return 'iridium';
        if (/P[YMCPB]/.test(r)) return 'platinum';
        return 'nickel';
    }
    return 'nickel';
}
